import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import CamdetectParkinglocationsTable from '../components/CamdetectParkinglocationsTable';
import CamdetectParkinglocationsForm from '../components/CamdetectParkinglocationsForm';

import CamdetectParkinglocationsModel from '../components/CamdetectParkinglocationsModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Icon, DatePicker, message } from 'antd';

class CamdetectParkinglocationsScreen extends Component {

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    camdetectParkinglocationsFormModalVisible: false,
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    this.setState({
      dataLoading: true
    });
    CamdetectParkinglocationsModel.getAll()
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Kamerová detekce - Seznam lokalit</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
              </Col>
              <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData() }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ camdetectParkinglocationsFormModalVisible: true }) }}>Nová lokalita</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <CamdetectParkinglocationsForm
            type="modal"
            modalVisible={this.state.camdetectParkinglocationsFormModalVisible}
            onModalCancel={() => { this.setState({ camdetectParkinglocationsFormModalVisible: false }) }}
            onSuccess={(form, values) => {
              CamdetectParkinglocationsModel.create(values)
                .then(() => {
                  form.resetFields();
                  this.loadData();
                })
                .catch(() => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />
          <CamdetectParkinglocationsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onDetailRow={(record) => {
            }}
            onRemoveRow={(id) => {
              CamdetectParkinglocationsModel.remove(id)
                .then(() => {
                  this.loadData();
                });
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default CamdetectParkinglocationsScreen;



// WEBPACK FOOTER //
// ./src/screens/CamdetectParkinglocationsScreen.js